import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LayoutComponent} from './layout.component';
import { SidePanelComponent } from './side-panel/side-panel.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {InnerLoaderModule} from '../inner-loader/inner-loader.module';


@NgModule({
  declarations: [
    LayoutComponent,
    SidePanelComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    InnerLoaderModule,
  ],
  exports: [
    LayoutComponent
  ]
})
export class LayoutModule { }
